import React, { Component } from 'react';
import './questions-list.scss';
import { Constants, ImageConstants } from '../../../../constants/constants';
import { getImageSource } from '../../../../utility/image-source'
import CwContentViewer from '../../../common/cw-content-viewer/cw-content-viewer'
import CanvasPreview from '../../../common/canvas/canvas'
import GeometryTranspiler from '../../../common/geometry/geometry-parser'
import ReactTooltip from 'react-tooltip';

class QuestionList extends Component {

    state = {
        isCompetecyQuestionsPresent: false
    }

    contentsHash = {}

    constructor(props) {
        super(props)

        console.log(this.props.approximateTime, this.props.contents)

        this.state = {
            contents: this.props.contents,
            reload: true,
            questionCount: this.props.questionCount,
            approximateTime: this.props.approximateTime,
            enableSelectionButton: false,
            showCompetencyOnly: this.props.showCompetencyOnly
        }

        if (Object.keys(this.props.contentsHash).length) {
            this.contentsHash = this.props.contentsHash
        } else {
            this.props.contents.forEach(skill => {
                if (skill.questions.length) {
                    skill.questions.forEach(item => {
                        this.contentsHash[item._id] = { contentId: item._id, eloId: item.eloId, selected: true }
                    })
                }
            });
        }



    }

    componentDidMount() {
        let isCompetecyQuestionsPresent = this.state.isCompetecyQuestionsPresent

        if (this.props.contents.length) {
            for (let i = 0; i < this.props.contents.length; i++) {
                let skill = this.props.contents[i]
                for (let j = 0; j < skill.questions.length; j++) {

                    let question = skill.questions[j]

                    if ((question.questionCategory === 'C1' ||
                        question.content.competency && question.content.competency.id === 'YES' ||
                        question.skill === 'Comprehension')) {
                        isCompetecyQuestionsPresent = true
                        break;
                    }
                }
            }
        }

        this.setState({ isCompetecyQuestionsPresent })
    }



    onClickBack = () => {
        this.props.back()
    }

    setSelectedQuestions = () => {
        if (this.props.questionCount != this.state.questionCount) {
            let obj = {
                selectedContentAssessment: true,
                contentsHash: this.contentsHash,
                approximateTime: this.state.approximateTime,
                questionCount: this.state.questionCount
            }
            this.props.delegate && this.props.delegate.setSelectedQuestions && this.props.delegate.setSelectedQuestions(obj)
        }


        if (this.state.showCompetencyOnly) {
            this.props.delegate && this.props.delegate.setSelectedQuestions && this.props.delegate.setSelectedQuestions()
        }
    }


    onSelectQuestion = (contentId, value, key) => {
        console.log(this.props.questionCount)

        if (this.contentsHash[contentId]) {

            this.contentsHash[contentId].selected = value

            let mins = 0

            if (value) {
                if (key === 'Knowledge') {
                    mins = 1  // 1 min for one Question
                } else if (key === 'Calculation') {
                    mins = 2 // 1.5 min for Each question
                } else if (key === 'Modelling') {
                    mins = 3 // 2.5 min for Each Question
                } else if (key === 'Comprehension') {
                    mins = 4 // 3.5 min for Each Question
                }

                this.setState({ questionCount: this.state.questionCount + 1, approximateTime: this.state.approximateTime + mins }, () => {
                    if (this.props.questionCount === this.state.questionCount) {
                        this.setState({ enableSelectionButton: false })
                    }
                })
            } else {
                if (key === 'Knowledge') {
                    mins = 1  // 1 min for one Question
                } else if (key === 'Calculation') {
                    mins = 2 // 1.5 min for Each question
                } else if (key === 'Modelling') {
                    mins = 3 // 2.5 min for Each Question
                } else if (key === 'Comprehension') {
                    mins = 4 // 3.5 min for Each Question
                }
                this.setState({ questionCount: this.state.questionCount - 1, approximateTime: this.state.approximateTime - mins }, () => {
                    if (this.props.questionCount != this.state.questionCount - 1) {
                        this.setState({ enableSelectionButton: true })
                    }
                })
            }



            this.setState({ reload: false }, () => {
                this.setState({ reload: true })
            })
        }
    }




    renderList = () => {

        let continousIndex = 1

        return (
            this.state.contents?.map((skill, index) => (
                <div className="concept-wrapper" onMouseEnter={ReactTooltip.rebuild}>
                    <div className="concept-title pt-2">{skill?.skill}</div>
                    <div >
                        {
                            skill.questions.map((question, qnIndex) => (
                                <div className='row pt-4 flex-no-wrap ' >
                                    {
                                        !this.props.questionSelection ?
                                            <div className='col-2 ml-0 elo-index pr-0 d-flex width-of-question-number'
                                            >
                                                <div className='ml-2'>{`Q${continousIndex++}`}</div>
                                            </div>
                                            :
                                            <div className='col-2 ml-0 elo-index pr-0 d-flex width-of-question-number cursor-pointer'
                                                onClick={() => this.onSelectQuestion(question._id, !this.contentsHash[question._id].selected, question.skill)}>
                                                <div>
                                                    {
                                                        this.state.reload && this.contentsHash[question._id] && this.contentsHash[question._id].selected ? <div className="">
                                                            <img className="green-tick-icon" src={getImageSource(ImageConstants.WHITE_CHECK_BOX)} />
                                                        </div>
                                                            :
                                                            <div className="check-box"></div>
                                                    }
                                                </div>
                                                <div className='ml-4'>{`Q${continousIndex++}`}</div>
                                            </div>
                                    }

                                    <div className='col'>
                                        <div className='qn-title'><CwContentViewer content={question.content.title} /></div>
                                        {question.content.images.length ? question.content.images.map((image, imageIndex) =>
                                            <img className='image-container mb-4 mr-3' src={image.imageUrl} alt="" />
                                        )
                                            :
                                            ""}
                                    </div>
                                    <div className='col-1 d-flex align-items-center'>
                                        {
                                            (question.questionCategory === 'C1' ||
                                                question.content.competency && question.content.competency.id === 'YES' ||
                                                question.skill === 'Comprehension') ?
                                                <img className='info-icon-size mr-2' src={getImageSource(ImageConstants.YELLOW_BULB)} />
                                                :
                                                <img className='info-icon-size no-image-margin-right'></img>
                                        }

                                        <img className='info-icon-size'
                                            data-tip={`${question.eloTitle}`}
                                            src={getImageSource(ImageConstants.INFO1)} />
                                    </div>
                                </div>
                            ))

                        }
                    </div>
                </div>
            ))
        )
    }

    showCompetency() {
        this.props.delegate && this.props.delegate.showCompetencyQuestionsOnly && this.props.delegate.showCompetencyQuestionsOnly(!this.state.showCompetencyOnly)
        this.setState({ showCompetencyOnly: !this.state.showCompetencyOnly })
    }


    render() {
        return (
            <div className='question-detail'>

                {
                    this.props.isAdaptive ?
                        <>
                            <div className="abs-image">
                                <img className='cursor-pointer header-image' src={getImageSource(ImageConstants.HEADER1)} />
                            </div>

                            <div className="pt-4 my-auto text-right"><img className='close-icon cursor-pointer' src={getImageSource(ImageConstants.CROSS)} onClick={this.onClickBack.bind(this)} /></div>
                        </>
                        :
                        <></>
                }


                <div className='mt-4 qs-font-weight'>Questions</div>
                <div className='mt-4 apx-time-size '>
                    <span className="question-bg-colour">
                        <span><img className='question-mark-icon-size' src={getImageSource(ImageConstants.QUESTION_MARK)} /><b className="pl-1"> {this.state.questionCount || 0}</b></span>
                    </span>
                    <span className="p-2 ml-5 duration-bg-colour"><span><img className='question-mark-icon-size' src={getImageSource(ImageConstants.CLOCK_IMAGE)} /> <b className="pl-1">{this.state.approximateTime || 0} </b>mins</span></span>
                    {/* <span className={` ml-5 ${this.state.enableSelectionButton ? 'enable-selection-button cursor-pointer' : 'selection-button'}`} onClick={this.setSelectedQuestions.bind(this)}>Set Selected Questions</span> */}
                </div>
                {
                    this.state.isCompetecyQuestionsPresent ?
                        // <div className='d-flex justify-content-end cursor-pointer' onClick={() => this.showCompetency()} >
                        //     {
                        //         this.state.showCompetencyOnly ?
                        //             <div>
                        //                 <img className="green-tick-icon-for-competency" src={getImageSource(ImageConstants.WHITE_CHECK_BOX)} />
                        //             </div>
                        //             :
                        //             <div>
                        //                 <div className="empty-check-box"></div>
                        //             </div>
                        //     }
                        //     <div className='d-flex align-items-center ml-2'>
                        //         <img className='yellow-bulb-icon mr-2' src={getImageSource(ImageConstants.YELLOW_BULB)} />
                        //         <span className='competency-text'>Show Competency Questions only</span>
                        //     </div>
                        // </div>
                        <></>
                        :
                        <></>
                    // <div className='d-flex justify-content-end cursor-pointer' onClick={() => this.showCompetency()} >

                    //     <div className='d-flex align-items-center ml-2'>
                    //         <img className='yellow-bulb-icon mr-2' src={getImageSource(ImageConstants.YELLOW_BULB)} />
                    //         <span className='competency-text'>No Competency Questions</span>
                    //     </div>
                    // </div>

                }

                <div className='qs-border mt-4'></div>
                <div>
                    {this.renderList()}
                </div>
                {
                    !this.props.questionSelection ?
                        <></>
                        :
                        <div className="modal-footer">
                            <button className="apply-btn" onClick={this.setSelectedQuestions.bind(this)} >Apply Selected</button>
                            <button className="cancel-btn" onClick={this.onClickBack.bind(this)} >Cancel</button>
                        </div>
                }

                <ReactTooltip className="border arrow" arrowColor="#C4C4C4" ref={el => this.tooltip = el}
                    multiline={true} place='bottom' type='light' effect='solid'
                    event="mouseover mouseenter"
                    eventOff="mouseleave mouseout scroll mousewheel blur"
                />
            </div >
        );
    }
}

export default QuestionList;